import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isUnprocessableEntity = (response: HttpErrorResponse): boolean => {
  return response.status === HttpStatusCode.UnprocessableEntity;
};
